import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    loadingPanels: false,
    loadingAverages: false
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
    setLoadingPanels(state, loading) {
      state.loadingPanels = loading
    },
    setLoadingAverages(state, loading) {
      state.loadingAverages = loading
    }
  },
  actions: {

  }
})
